import { Component, inject, signal } from "@angular/core";
import { ConfirmationService, PrimeTemplate } from 'primeng/api';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { AbstractListController } from 'src/app/common/abstract-list.component';
import { PARAM_PERSONAL_DATA_PATH } from 'src/app/constants/constants';
import { Personal_data } from 'src/app/models/personal_data';
import { PersonalDataService } from 'src/app/services/personal_data.service';
import { Bind } from 'primeng/bind';
import { Drawer } from 'primeng/drawer';
import { FormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { ButtonDirective } from 'primeng/button';

import { TableModule } from 'primeng/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { TranslatePipe } from '@ngx-translate/core';

import { DynamicFiltersComponent } from "../../../components/dynamic-filters/dynamic-filters.component";
import { TPipe } from "../../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-manage-personal-data',
    templateUrl: './manage-personal-data.component.html',
    imports: [TPipe, DynamicFiltersComponent, Bind, Drawer, PrimeTemplate, FormsModule, InputText, ButtonDirective, RouterLink, TableModule, NgxPaginationModule, ConfirmDialog, TranslatePipe]
})
export class ManagePersonalDataComponent extends AbstractListController<Personal_data, any> {
  protected sersonalDataService: PersonalDataService;
  protected confirmationService: ConfirmationService;

  title = 'Dati personali';
  readonly cols = signal<any[]>(undefined);
  readonly columnOptions = signal<any[]>(undefined);
  readonly selectedColumns = signal<any[]>(undefined);

  constructor() {
    const sersonalDataService = inject(PersonalDataService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(sersonalDataService, confirmationService, router, route, PARAM_PERSONAL_DATA_PATH);
    this.sersonalDataService = sersonalDataService;
    this.confirmationService = confirmationService;

    this.cols.set([
      { field: 'name', header: 'Nome', index: 1 },
      { field: 'description', header: 'Descrizione', index: 2 }
    ]);
    this.colsFilter.set([
      { field: "name", icon: "pi-tag", header: "Nome", type: "string" },
      { field: "description", icon: "pi-align-left", header: "Descrizione", type: "string" },
    ]);


    this.columnOptions.set([]);
    this.selectedColumns.set([]);
    for (let i = 0; i < this.cols().length; i++) {
      this.columnOptions.update((a) => { a.push({ label: this.cols()[i].header, value: this.cols()[i] }); return [...a]; });
    }
  }




}
